import { useContext, useEffect, useState } from "react";
import React from "react";
import { PieChart } from "@mui/x-charts/PieChart";
import { useDrawingArea } from "@mui/x-charts/hooks";
import { styled } from "@mui/material/styles";
import { UserAuthContext } from "../../App";
import { useNavigate } from "react-router-dom";
import { allProductForStoreWebApi } from "../../Apis/ProductApi";
import { sellerOrderOverviewApi, sellerOverviewApi } from "../../Apis/OrderApi";
import { LineChart } from "@mui/x-charts/LineChart";
import { getSellerOrderRevenue } from "../../Apis/OrderApi";

import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  Line,
  CartesianGrid,
} from "recharts";

import { GreyLogoSVG } from "../../assets/svg/allSvg";
// import { OutOfStock, InStock } from "../UI/StockStatus";

// const InStock = require("../../components/UI/StockStatus").default

const data = [
  { name: "Oct 2023", revenue: 1 },
  { name: "Nov 2023", revenue: 2 },
  { name: "Dec 2023", revenue: 3 },
  { name: "Jan 2024", revenue: 2.5 },
  { name: "Feb 2024", revenue: 4 },
  { name: "Mar 2024", revenue: 3.5 },
];
const products = [
  {
    id: 1,
    name: "Apple iPhone 13 Pro Max (128 GB) 4GB RAM",
    price: 50000,
    rating: (
      <div className="w-full flex items-center justify-center">
        <button className="w-[70px] h-[33px] bg-[#C1FFA6] rounded-[5px] font-medium text-[12px] flex items-center justify-center text-black">
          In Stock
        </button>
      </div>
    ),
    unitsSold: 50,
  },
  {
    id: 2,
    name: "Apple iPhone 13 Pro Max (128 GB) 4GB RAM",
    price: 50000,
    rating: (
      <div className="w-full flex items-center justify-center">
        <button className="w-[100px] h-[33px] bg-[#FFD3CD] rounded-[5px] font-medium text-[12px] flex items-center justify-center text-black">
          Out of Stock
        </button>
      </div>
    ),
    unitsSold: 50,
  },
  {
    id: 3,
    name: "Apple iPhone 13 Pro Max (128 GB) 4GB RAM",
    price: 50000,
    rating: (
      <div className="w-full flex items-center justify-center">
        <button className="w-[70px] h-[33px] bg-[#C1FFA6] rounded-[5px] font-medium text-[12px] flex items-center justify-center text-black">
          In Stock
        </button>
      </div>
    ),
    unitsSold: 50,
  },
  {
    id: 4,
    name: "Apple iPhone 13 Pro Max (128 GB) 4GB RAM",
    price: 50000,
    rating: (
      <div className="w-full flex items-center justify-center">
        <button className="w-[70px] h-[33px] bg-[#C1FFA6] rounded-[5px] font-medium text-[12px] flex items-center justify-center text-black">
          In Stock
        </button>
      </div>
    ),
    unitsSold: 50,
  },
];

const data1 = [
  { value: 5, label: "A" },
  { value: 10, label: "B" },
  { value: 15, label: "C" },
  { value: 20, label: "D" },
];

const SellerOverview = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("This Month");
  const navigate = useNavigate(); // Add this line to use the useNavigate hook
  const [productData, setProductData] = useState([]);
  const [dropdownOpen1, setDropdownOpen1] = useState(false);
  const [selectedOption1, setSelectedOption1] = useState("This Month");
  const [orderDetails, setOrderDetails] = useState([]);
  const [monthOrderDetails, setMonthOrderDetails] = useState([]);
  const { userUid } = useContext(UserAuthContext);
  const [revenue, setRevenue] = useState(null);
  const [month, setMonth] = useState(0);
  const [value, setValue] = useState([]);
  const [maxRevenue, setMaxRevenue] = useState(0);

  useEffect(() => {
    const fetchRevenue = async () => {
      const response = await getSellerOrderRevenue(month);
      const transformedData = response?.orders?.map(order => ({
        ...order,
        revenue: order.revenue, // Keeping the original revenue values
      }));

        setValue(transformedData);

        if (response?.orders?.length > 0){
          const maxRevenueValue = Math.max(...transformedData?.map(order => order.revenue));
          setMaxRevenue(maxRevenueValue);
        }
      };

    fetchRevenue();
  }, [month]);

  const formatYAxisTick = (value) => {
    if (value >= 100000) {
      return `${Math.round(value / 100000)} L`; // Convert to lacs and round to nearest whole number
    } else if (value >= 1000) {
      return `${Math.round(value / 1000)} K`; // Convert to thousands and round to nearest whole number
    }
    return Math.round(value); // Round the value for display
  };


  useEffect(() => {
    const getProduct = async () => {
      const response = await allProductForStoreWebApi(
        userUid?.currentUser?.uid
      );
      setProductData(response?.products);
    };
    getProduct();
  }, []);

  // get seller total order details
  useEffect(() => {
    const getOrderDetails = async () => {
      const response = await sellerOverviewApi();
      setOrderDetails(response?.orders);
    };
    getOrderDetails();
  }, []);

  // get seller order details according to months
  useEffect(() => {
    const getOrderDetails = async () => {
      let month = 0;

      if (selectedOption === "Past 3 Months") month = 3;
      else if (selectedOption === "Past 6 Months") month = 6;
      else if (selectedOption === "Past 1 Year") month = 12;
      else month = 0;

      const response = await sellerOrderOverviewApi(month);
      setMonthOrderDetails(response?.orders);
    };
    getOrderDetails();
  }, [selectedOption]);

  const CustomLineChart = () => {
    const xAxisData = [
      "Oct 2023",
      "Nov 2023",
      "Dec 2023",
      "Jan 2024",
      "Feb 2024",
      "Apr 2024",
    ];
    const seriesData = [0, 1, 2, 3, 4, 5];
  };

  // ... rest of your component code ...

  const handleViewAllInquiries = () => {
    navigate("/SellerDashboard/SellerInquiry"); // Redirect to inquiries page
  };

  const handleViewAllOrders = () => {
    navigate("/SellerDashboard/ReceivedOrders"); // Redirect to wishlist page
  };

  const handleViewAllFollowers = () => {
    navigate("/SellerDashboard/SellerFollowers"); // Redirect to Profile Details page
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const toggleDropdown1 = () => {
    setDropdownOpen1(!dropdownOpen1);
  };

  const handleOptionClick1 = (option, monthIndex) => {
    setSelectedOption1(option);
    setMonth(monthIndex);
    setDropdownOpen1(false);
  };

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setDropdownOpen(false);
  };

  const size = {
    width: 400,
    height: 200,
  };

  const StyledText = styled("text")(({ theme }) => ({
    fill: theme.palette.text.primary,
    textAnchor: "middle",
    dominantBaseline: "central",
    fontSize: 20,
  }));

  function PieCenterLabel({ children }) {
    const { width, height, left, top } = useDrawingArea();
    return (
      <StyledText x={left + width / 2} y={top + height / 2}>
        {children}
      </StyledText>
    );
  }

  return (
    <>
      {/* <div className="w-full h-[1000px] flex items-center justify-center"> */}
      <div className="w-[1014px] h-[935px] bg-[#FFF9F2] rounded-r-[10px] pt-[25px] pl-[37px] pb-[28px] pr-[39px] flex flex-col">
        <div className="flex justify-between items-end">
          <div className="flex flex-col gap-y-[11px]">
            <h3 className="w-[103px] h-[27px] font-semibold text-[18px] text-start text-black">
              Dashboard
            </h3>
            <hr className="w-[152px] h-[3px] bg-[#FF6300]" />
          </div>
          <button className="w-[50px] h-[49px] bg-white rounded-[5px] flex items-center justify-center drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)]">
            <svg
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_440_352)">
                <path
                  d="M10.416 5.20833C10.416 4.6558 10.6355 4.12589 11.0262 3.73519C11.4169 3.34449 11.9468 3.125 12.4993 3.125C13.0519 3.125 13.5818 3.34449 13.9725 3.73519C14.3632 4.12589 14.5827 4.6558 14.5827 5.20833C15.7789 5.77399 16.7987 6.65451 17.5327 7.75552C18.2667 8.85653 18.6873 10.1365 18.7494 11.4583V14.5833C18.8277 15.2309 19.0571 15.8511 19.4189 16.3939C19.7808 16.9367 20.265 17.3869 20.8327 17.7083H4.16602C4.73366 17.3869 5.2179 16.9367 5.57975 16.3939C5.9416 15.8511 6.17096 15.2309 6.24935 14.5833V11.4583C6.31139 10.1365 6.73195 8.85653 7.46596 7.75552C8.19997 6.65451 9.21976 5.77399 10.416 5.20833Z"
                  stroke="black"
                  stroke-width="1.83333"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M9.375 17.7083V18.7499C9.375 19.5787 9.70424 20.3736 10.2903 20.9596C10.8763 21.5457 11.6712 21.8749 12.5 21.8749C13.3288 21.8749 14.1237 21.5457 14.7097 20.9596C15.2958 20.3736 15.625 19.5787 15.625 18.7499V17.7083"
                  stroke="black"
                  stroke-width="1.83333"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_440_352">
                  <rect width="25" height="25" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </button>
        </div>

        <div className="w-full h-[96px] gap-x-[18px] mt-[18px] flex flex-row">
          <div className="w-[221px] h-[96px] bg-white rounded-[10px] py-[19px] pr-[14px] flex items-start drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)]">
            <p className="w-[9px] h-[57px] bg-[#6FC33B] rounded-r-full"></p>
            <div className="flex flex-col h-[60px] justify-between ml-[18px]">
              <h4 className="w-[101px] h-[21px] font-semibold text-[14px] text-black text-start">
                Total Revenue
              </h4>
              <p className="w-[105px] h-[30px] font-semibold text-[20px] text-black text-start">
                ₹ {orderDetails?.totalPaymentAmount || 0}
              </p>
            </div>
            <svg
              width="32"
              height="32"
              className="ml-[43px]"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_440_393)">
                <path
                  d="M22.6673 10.6666V6.66659C22.6673 6.31296 22.5268 5.97383 22.2768 5.72378C22.0267 5.47373 21.6876 5.33325 21.334 5.33325H8.00065C7.29341 5.33325 6.61513 5.6142 6.11503 6.1143C5.61494 6.6144 5.33398 7.29267 5.33398 7.99992M5.33398 7.99992C5.33398 8.70716 5.61494 9.38544 6.11503 9.88554C6.61513 10.3856 7.29341 10.6666 8.00065 10.6666H24.0007C24.3543 10.6666 24.6934 10.8071 24.9435 11.0571C25.1935 11.3072 25.334 11.6463 25.334 11.9999V15.9999M5.33398 7.99992V23.9999C5.33398 24.7072 5.61494 25.3854 6.11503 25.8855C6.61513 26.3856 7.29341 26.6666 8.00065 26.6666H24.0007C24.3543 26.6666 24.6934 26.5261 24.9435 26.2761C25.1935 26.026 25.334 25.6869 25.334 25.3333V21.3333"
                  stroke="#D9D9D9"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M26.666 16V21.3333H21.3327C20.6254 21.3333 19.9472 21.0524 19.4471 20.5523C18.947 20.0522 18.666 19.3739 18.666 18.6667C18.666 17.9594 18.947 17.2811 19.4471 16.781C19.9472 16.281 20.6254 16 21.3327 16H26.666Z"
                  stroke="#D9D9D9"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_440_393">
                  <rect width="32" height="32" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>

          <div className="w-[221px] h-[96px] bg-white rounded-[10px] py-[19px] pr-[14px] flex items-start drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)]">
            <p className="w-[9px] h-[57px] bg-[#85B6FF] rounded-r-full"></p>
            <div className="flex flex-col h-[60px] justify-between ml-[18px]">
              <h4 className="w-[117px] h-[21px] font-semibold text-[14px] text-black text-start">
                Received Orders
              </h4>
              <p className="w-[25px] h-[30px] font-semibold text-[20px] text-black text-start">
                {orderDetails?.totalOrders || 0}
              </p>
            </div>
            <div className="flex flex-col items-end justify-between h-full">
              <svg
                width="32"
                height="32"
                className="ml-[30px]"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_440_376)">
                  <path
                    d="M6.66602 6.66667C6.66602 5.95942 6.94697 5.28115 7.44706 4.78105C7.94716 4.28095 8.62544 4 9.33268 4H22.666C23.3733 4 24.0515 4.28095 24.5516 4.78105C25.0517 5.28115 25.3327 5.95942 25.3327 6.66667V25.3333C25.3327 26.0406 25.0517 26.7189 24.5516 27.219C24.0515 27.719 23.3733 28 22.666 28H9.33268C8.62544 28 7.94716 27.719 7.44706 27.219C6.94697 26.7189 6.66602 26.0406 6.66602 25.3333V6.66667Z"
                    stroke="#D9D9D9"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12 9.33325H20"
                    stroke="#D9D9D9"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12 14.6667H20"
                    stroke="#D9D9D9"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12 20H17.3333"
                    stroke="#D9D9D9"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_440_376">
                    <rect width="32" height="32" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <button
                className="w-[47px] h-[18px] font-medium text-[#FF6300] text-[12px]"
                onClick={handleViewAllOrders}
              >
                View All
              </button>
            </div>
          </div>

          <div className="w-[221px] h-[96px] bg-white rounded-[10px] py-[19px] pr-[14px] flex items-start drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)]">
            <p className="w-[9px] h-[57px] bg-[#FFD233] rounded-r-full"></p>
            <div className="flex flex-col h-[60px] justify-between ml-[18px]">
              <h4 className="w-[121px] h-[21px] font-semibold text-[14px] text-black text-start">
                Product Inquiries
              </h4>
              <p className="w-[21px] h-[30px] font-semibold text-[20px] text-black text-start">
                {orderDetails?.totalProductEnquiry || 0}
              </p>
            </div>
            <div className="flex flex-col items-end justify-between h-full">
              <svg
                width="31"
                height="31"
                className="ml-[28px]"
                viewBox="0 0 31 31"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_440_382)">
                  <path
                    d="M16.5361 2.79636L23.7371 5.88216C24.3571 6.14824 24.8518 6.64295 25.1192 7.26424L28.2037 14.464C28.4879 15.1253 28.4879 15.8745 28.2037 16.5358L25.1179 23.7369C24.8518 24.3569 24.3571 24.8516 23.7358 25.119L16.5361 28.2034C15.8747 28.4876 15.1256 28.4876 14.4642 28.2034L7.26319 25.1177C6.64205 24.8516 6.14714 24.3567 5.88111 23.7356L2.79661 16.5358C2.65632 16.2085 2.58398 15.856 2.58398 15.4999C2.58398 15.1438 2.65632 14.7913 2.79661 14.464L5.8824 7.26295C6.14848 6.64295 6.64319 6.14824 7.26448 5.88086L14.4642 2.79636C14.7916 2.65608 15.144 2.58374 15.5002 2.58374C15.8563 2.58374 16.2087 2.65608 16.5361 2.79636Z"
                    stroke="#D9D9D9"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M15.5 20.6667V20.6788"
                    stroke="#D9D9D9"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M15.5 16.7916C16.0809 16.7934 16.6455 16.5992 17.1025 16.2406C17.5595 15.882 17.8823 15.3798 18.0188 14.8151C18.1553 14.2505 18.0974 13.6563 17.8546 13.1285C17.6118 12.6008 17.1982 12.1703 16.6806 11.9065C16.1667 11.6433 15.5789 11.5617 15.0128 11.675C14.4467 11.7882 13.9355 12.0897 13.5625 12.5304"
                    stroke="#D9D9D9"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_440_382">
                    <rect width="31" height="31" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <button
                className="w-[47px] h-[18px] font-medium text-[#FF6300] text-[12px]"
                onClick={handleViewAllInquiries}
              >
                View All
              </button>
            </div>
          </div>

          <div className="w-[221px] h-[96px] bg-white rounded-[10px] py-[19px] pr-[14px] flex items-start drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)]">
            <p className="w-[9px] h-[57px] bg-[#868BFF] rounded-r-full"></p>
            <div className="flex flex-col h-[60px] justify-between ml-[18px]">
              <h4 className="w-[67px] h-[21px] font-semibold text-[14px] text-black text-start">
                Followers
              </h4>
              <p className="w-[21px] h-[30px] font-semibold text-[20px] text-black text-start">
                0
              </p>
            </div>
            <div className="flex flex-col items-end justify-between h-full">
              <svg
                width="28"
                height="28"
                className="ml-[84px]"
                viewBox="0 0 28 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_440_387)">
                  <path
                    d="M5.83398 8.16667C5.83398 9.40434 6.32565 10.5913 7.20082 11.4665C8.07599 12.3417 9.26297 12.8333 10.5007 12.8333C11.7383 12.8333 12.9253 12.3417 13.8005 11.4665C14.6757 10.5913 15.1673 9.40434 15.1673 8.16667C15.1673 6.92899 14.6757 5.742 13.8005 4.86683C12.9253 3.99167 11.7383 3.5 10.5007 3.5C9.26297 3.5 8.07599 3.99167 7.20082 4.86683C6.32565 5.742 5.83398 6.92899 5.83398 8.16667Z"
                    stroke="#D9D9D9"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M3.5 24.5V22.1667C3.5 20.929 3.99167 19.742 4.86683 18.8668C5.742 17.9917 6.92899 17.5 8.16667 17.5H12.8333C14.071 17.5 15.258 17.9917 16.1332 18.8668C17.0083 19.742 17.5 20.929 17.5 22.1667V24.5"
                    stroke="#D9D9D9"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M18.666 3.65161C19.6698 3.90863 20.5596 4.49243 21.1949 5.31097C21.8303 6.12952 22.1752 7.13625 22.1752 8.17245C22.1752 9.20864 21.8303 10.2154 21.1949 11.0339C20.5596 11.8525 19.6698 12.4363 18.666 12.6933"
                    stroke="#D9D9D9"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M24.5 24.5V22.1667C24.4941 21.1367 24.1476 20.1376 23.5145 19.3252C22.8814 18.5127 21.9973 17.9325 21 17.675"
                    stroke="#D9D9D9"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_440_387">
                    <rect width="28" height="28" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <button
                className="w-[47px] h-[18px] font-medium text-[#FF6300] text-[12px]"
                onClick={handleViewAllFollowers}
              >
                View All
              </button>
            </div>
          </div>
        </div>

        <div className="flex flex-row justify-between w-full h-[344px] mt-[17px]">
          <div className="w-[622px] h-[344px] bg-white rounded-[10px] drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)]">
            <div className="flex m-4 justify-between">
              <div className="w-[89px] h-[21px] font-semibold text-[14px]">
                Sales Report
              </div>
              <div className="flex">
                <p className="font-semibold text-[14px]">Total Revenue :</p>
                <p className="w-[190px] h-[30px] font-semibold text-[14px] text-[#FF6300] ">
                  ₹ {orderDetails?.totalPaymentAmount || 0}
                </p>
              </div>
              <div className="flex flex-col items-start">
                <button
                  className="flex flex-row items-center justify-between border-black w-[127px] h-[30px] bg-[#F8F8F8] drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)] rounded-[5px] py-[6px] pl-[9px] pr-[5px]"
                  onClick={toggleDropdown1}
                >
                  <h3 className="w-auto h-[18px] font-medium text-[12px]">
                    {selectedOption1}
                  </h3>
                  <svg
                    width="9"
                    height="6"
                    viewBox="0 0 9 6"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.81795 5.36389C4.20208 5.72215 4.79792 5.72215 5.18205 5.36389L8.27282 2.48131C8.9367 1.86214 8.49857 0.75 7.59077 0.75H1.40923C0.501428 0.75 0.0632989 1.86214 0.72718 2.48131L3.81795 5.36389Z"
                      fill="black"
                    />
                  </svg>
                </button>
                {dropdownOpen1 && (
                  <div className="absolute top-[50px] right-[10px] mt-2 py-2 w-48 bg-white border rounded-[5px] drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)] z-50">
                    <a
                      href="#"
                      className="block px-4 py-2 text-black hover:text-[#FF6300] font-semibold text-[14px]"
                      onClick={() => handleOptionClick1("This Month", 0)}
                    >
                      This Month
                    </a>
                    <a
                      href="#"
                      className="block px-4 py-2 text-black hover:text-[#FF6300] font-semibold text-[14px]"
                      onClick={() => handleOptionClick1("Past 3 Months", 3)}
                    >
                      Past 3 Months
                    </a>
                    <a
                      href="#"
                      className="block px-4 py-2 text-black hover:text-[#FF6300] font-semibold text-[14px]"
                      onClick={() => handleOptionClick1("Past 6 Months", 6)}
                    >
                      Past 6 Months
                    </a>
                    <a
                      href="#"
                      className="block px-4 py-2 text-black hover:text-[#FF6300] font-semibold text-[14px]"
                      onClick={() => handleOptionClick1("Past 1 Year", 12)}
                    >
                      Past 1 Year
                    </a>
                  </div>
                )}
              </div>
            </div>
            {/* <LineChart
              xAxis={[{ data: [1, 2, 3, 5, 8, 10] }]}
              series={[
                {
                  data: [2, 5.5, 2, 8.5, 1.5, 5],
                  area: true,
                },
              ]}
              width={600}
              height={300}
            /> */}


            <div
              style={{
                padding: "10px",
                borderRadius: "5px",
                width: "fit-content",
              }}
            >
              <AreaChart width={600} height={250} data={value}>
                <defs>
                  <linearGradient id="colorGradient" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#FF6300" />
                    <stop offset="50%" stopColor="#FF9A62" />
                    <stop offset="100%" stopColor="#FFFFFF" />
                  </linearGradient>
                </defs>

                <XAxis dataKey="name" tick={{ fontSize: 10, fill: "grey" }} />
                <YAxis
                  label={{
                    value: "Revenue",
                    angle: -90,
                    position: "outsideLeft",
                    fontSize: 14,
                    fill: "grey",
                    dx: -10,
                    dy: 10,
                  }}
                  domain={[10000, maxRevenue > 1000000 ? maxRevenue : 1000000]}
                  tickCount={6}
                  tickFormatter={formatYAxisTick}
                />
                <Tooltip formatter={(value) => `${Math.round(value)} ${value >= 100000 ? 'L' : value >= 1000 ? 'K' : ''}`} />
                <Legend />
                <Area
                  type="monotone"
                  dataKey="revenue"
                  stroke="#FF6300"
                  fill="url(#colorGradient)"
                />
                <Line type="monotone" dataKey="revenue" stroke="#FF6300" />
              </AreaChart>
            </div>

          </div>
          <div className="w-[299px] h-[344px] bg-white rounded-[10px] drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)] pt-[18px] pl-[15px] pr-[11px] pb-[19px] flex flex-col">
            <div className="w-full flex items-center justify-between">
              <p className="w-[99px] h-[21px] font-semibold text-[14px] text-black text-start">
                Orders Report
              </p>
              <button
                className="flex flex-row items-center justify-between border-black w-[127px] h-[30px] bg-[#F8F8F8] drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)] rounded-[5px] py-[6px] pl-[9px] pr-[5px]"
                onClick={toggleDropdown}
              >
                <h3 className="w-auto h-[18px] font-medium text-[12px]">
                  {selectedOption}
                </h3>
                <svg
                  width="9"
                  height="6"
                  viewBox="0 0 9 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.81795 5.36389C4.20208 5.72215 4.79792 5.72215 5.18205 5.36389L8.27282 2.48131C8.9367 1.86214 8.49857 0.75 7.59077 0.75H1.40923C0.501428 0.75 0.0632989 1.86214 0.72718 2.48131L3.81795 5.36389Z"
                    fill="black"
                  />
                </svg>
              </button>
              {dropdownOpen && (
                <>
                  <div className="absolute top-[50px] right-[10px] mt-2 py-2 w-48 bg-white border rounded-[5px] drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)] z-50">
                    <a
                      href="#"
                      className="block px-4 py-2 text-black hover:text-[#FF6300] font-semibold text-[14px]"
                      onClick={() => handleOptionClick("This Month")}
                    >
                      This Month
                    </a>
                    <a
                      href="#"
                      className="block px-4 py-2 text-black hover:text-[#FF6300] font-semibold text-[14px]"
                      onClick={() => handleOptionClick("Past 3 Months")}
                    >
                      Past 3 Months
                    </a>
                    <a
                      href="#"
                      className="block px-4 py-2 text-black hover:text-[#FF6300] font-semibold text-[14px]"
                      onClick={() => handleOptionClick("Past 6 Months")}
                    >
                      Past 6 Months
                    </a>
                    <a
                      href="#"
                      className="block px-4 py-2 text-black hover:text-[#FF6300] font-semibold text-[14px]"
                      onClick={() => handleOptionClick("Past 1 Year")}
                    >
                      Past 1 Year
                    </a>
                  </div>
                </>
              )}
            </div>
            <div className="w-full h-[188px] flex items-center justify-center">
              {/* <PieChart series={[{ data, innerRadius: 82 }]} {...size}>
                <PieCenterLabel
                  className={`w-[100px] h-[24px] font-semibold text-[16px] text-black`}
                >
                  Total Orders
                </PieCenterLabel>
              </PieChart> */}
            </div>
            <div className="w-[266px] h-[89px] flex flex-col justify-between pl-[3px]">
              <div className="w-full gap-x-[13px] flex items-center justify-between">
                <div className="flex flex-row gap-x-[12px] items-center justify-start">
                  <p className="w-[13px] h-[13px] bg-[#72C62F] rounded-full"></p>
                  <p className="w-[104px] h-[18px] font-medium text-[12px] text-black">
                    Orders Complete
                  </p>
                </div>
                <p className="w-[14px] h-[21px] font-semibold text-[14px] text-black ">
                  {monthOrderDetails?.CompletedCount || 0}
                </p>
              </div>

              <div className="w-full gap-x-[13px] flex items-center justify-between">
                <div className="flex flex-row gap-x-[12px] items-center justify-start">
                  <p className="w-[13px] h-[13px] bg-[#7297F6] rounded-full"></p>
                  <p className="w-[105px] h-[18px] font-medium text-[12px] text-black">
                    Orders In Process
                  </p>
                </div>
                <p className="w-[14px] h-[21px] font-semibold text-[14px] text-black ">
                  {monthOrderDetails?.InProcessCount || 0}
                </p>
              </div>

              <div className="w-full gap-x-[13px] flex items-center justify-between">
                <div className="flex flex-row gap-x-[12px] items-center justify-start">
                  <p className="w-[13px] h-[13px] bg-[#FF5454] rounded-full"></p>
                  <p className="w-[106px] h-[18px] font-medium text-[12px] text-black">
                    Orders Cancelled
                  </p>
                </div>
                <p className="w-[14px] h-[21px] font-semibold text-[14px] text-black">
                  {monthOrderDetails?.CancelledCount || 0}
                </p>
              </div>
            </div>
          </div>
        </div>

        {productData?.length === 0 ? (
          <div className="flex flex-col items-center justify-center h-full gap-y-[41px]">
            {GreyLogoSVG}

            <p className="w-[200px] h-[30px] font-semibold text-[20px] text-black text-center">
              No Products yet !!
            </p>
          </div>
        ) : (
          <div className="w-full h-[346px] bg-white rounded-[10px] mt-[17px] drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)] flex flex-col pt-[18px] pl-[20px] pr-[38px]">
            <div className="w-full items-center justify-between flex">
              <p className="w-[88px] h-[21px] font-semibold text-[14px]">
                My Products
              </p>
              <div className="flex flex-row gap-x-[4px]">
                <p className="w-[110px] h-[21px] text-black font-semibold text-[14px]">
                  Total Products :{" "}
                </p>
                <p className="w-[10px] h-[21px] font-semibold text-[14px] text-[#FF6300]">
                  {productData?.length}
                </p>
              </div>
            </div>

            <div className="mt-[20px]">
              <table className="w-full text-center table-auto text-black">
                <thead>
                  <tr className="text-[14px] font-medium text-center h-[45px]">
                    <th className="p-2 text-start">Sr No.</th>
                    <th className="p-2 text-start pl-[20px]">Product</th>
                    <th className="p-2">Price</th>
                    <th className="p-2">Product Rating</th>
                    <th className="p-2">Units Sold</th>
                  </tr>
                </thead>
                <tbody>
                  {productData?.map((product, index) => (
                    <tr
                      key={index}
                      className="border-t-[1px] h-[56px] font-medium text-[12px] border-t-[#F2F2F2]"
                    >
                      <td className="p-2">{index + 1}</td>
                      <td className="flex items-center justify-start text-start h-[56px] gap-x-[15px]">
                        <img
                          src={require("../../assets/SellerDashboard/SellerOverview/image 132.jpg")}
                          alt=""
                          className="w-[29px] h-[33px]"
                        />
                        {product?.productTitle}
                      </td>
                      <td className="p-2">₹ {product?.maxPrice}</td>
                      <td className="p-2">{product?.stockStatus}</td>
                      <td className="p-2">{product?.unitsSold}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
      {/* </div> */}
    </>
  );
};

export default SellerOverview;
